document.addEventListener("DOMContentLoaded", () => {
    const options = [{
        "key": "swipe",
        "value": "swipe",
        "label": fiDeleteData
    }, {
        "key": "loan-application-problem",
        "value": "loan-application-problem",
        "label": fiLoanApplicationProblem
    }, {
        "key": "question-about-loan",
        "value": "question-about-loan",
        "label": fiQuestionAboutLoan
    }, {
        "key": "other",
        "value": "other",
        "label": fiOtherQuestion
    }]

    const select = document.querySelector('fi-select');
    const button = document.querySelector('#form fi-button')

    let text = $('#other-text');
    let textField = $('#text-field');
    let swipeText = $('#swipe-text');
    let email = $('#email');
    let submitButton = $('#submit-button');
    let captcha = $('.g-recaptcha');
    let swipeForm = $("#form");
    let loanApplicationText = $('#loan-application-text');
    let questionAboutLoanText = $('#question-about-loan-text');
    let name = $('#name');


    function hideAllFields() {
        loanApplicationText.hide();
        questionAboutLoanText.hide();
        swipeText.hide();
        text.hide();
        textField.hide();

        email.hide();
        submitButton.hide();
        captcha.hide();
    }

    hideAllFields();

    select.options = options;
    select.addEventListener('fiInput', evt => {
        hideAllFields();
        select.value = evt.detail;
        if (evt.detail === 'loan-application-problem') {
            submitButton.show();
            textField.show();
            email.show();
            loanApplicationText.show();
            captcha.show();
        } else if (evt.detail === 'question-about-loan') {
            questionAboutLoanText.show();
        } else if (evt.detail === "swipe") {
            submitButton.show();
            swipeText.show();
            email.show();
            captcha.show();
        } else {
            submitButton.show();
            text.show();
            textField.show();
            email.show();
            captcha.show();
        }
        document.querySelector('.contact-form-select').value = evt.detail;
    });
    const emailRegex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
    const fiEmail = document.querySelector('.email')
    fiEmail.addEventListener('fiInput', ev => {
        fiEmail.value = ev.detail.unmasked;
        document.querySelector('#from-name').value = ev.detail.unmasked;
        emailRegex.test(ev.detail.unmasked) ? fiEmail.validationClass = 'valid' : fiEmail.validationClass = 'error'
    })

    function submitForm(event) {
        if (swipeForm.find("#g-recaptcha-response").val() === '' || select.value === 'question-about-loan' || name.val() !== '') {
            event.preventDefault();
            return
        }
        submitButton.attr("disabled", true);
        submitButton.attr("loading", true);
        if (select.value === "swipe") {
            event.preventDefault();
            var email = swipeForm.find("input[name='fromEmail']").val(),
                CSRF = swipeForm.find("input[name='CSRF']").val(),
                gRecaptchaResponse = swipeForm.find('input[name="g-recaptcha-response"]').val(),
                url = app.config.apiUrl + '/api/v1/profile/send_swipe_email';

            var posting = $.post(url, {
                CSRF: CSRF,
                email: email,
                'g-recaptcha-response': gRecaptchaResponse,
                language: app.config.lang
            });

            posting.done(function (data) {
                swipeForm.hide();
                submitButton.attr("disabled", false);
                var content = fiMessageSentText;
                $("#result").empty().append(content);
            });

            posting.fail(function (data) {
                swipeForm.hide();
                var content = `<h2>${fiErrorMessageText}</h2>`;
                $("#result").empty().append(content);
                submitButton.attr("disabled", false);
            });
        } else {
            swipeForm[0].submit()
        }
    }

    button.addEventListener('click', (event) => {
        grecaptcha.execute(app.config.siteKey, {action: 'contactform'}).then(function(token) {
            swipeForm.find('input[name="g-recaptcha-response"]')[0].value = token;
            submitForm(event)
        });
    });
});
